module.exports = __webpack_public_path__ + "img/cloudSun__.a6d47ee6.svg";